export const Data=[
    //Courses List
    {
        id:1,
        Semester:"1",
        CourseCode:"CSCS1511",
        CourseTitle:"Introduction to Computer",
        Add:true,
        CourseType:"CORE",
        Sections:[
       //Course Sections list
            {
              Section:"E1",
              Status:"Open",
              Teacher:"Sameer Shahid",
              Capacity:50,
              CurrentCapacity:4,
              Days:[
                  {
                    StartTime:"08:00AM",
                    EndTime:"09:20AM",
                    Day:"MONDAY",
                    Place:"A001"
                  },
                  {
                    StartTime:"08:00AM",
                    EndTime:"09:20AM",
                    Day:"WEDNESDAY",
                    Place:"A001"
                  }
                ]
            },
            {
                Section:"E2",
                Status:"Open",
                Teacher:"Sameer Shahid",
                Capacity:50,
                CurrentCapacity:30,
                Days:[
                    {
                      StartTime:"09:30AM",
                      EndTime:"10:50AM",
                      Day:"TUESDAY",
                      Place:"A002"
                    },
                    {
                      StartTime:"08:00AM",
                      EndTime:"09:20AM",
                      Day:"FRIDAY",
                      Place:"A003"
                    }
                ]
            },
            {
                Section:"E3",
                Status:"Open",
                Teacher:"Hannan Tariq",
                Capacity:50,
                CurrentCapacity:49,
                Days:[
                    {
                      StartTime:"09:30AM",
                      EndTime:"10:50AM",
                      Day:"MONDAY",
                      Place:"A003"
                    },
                    {
                      StartTime:"08:00AM",
                      EndTime:"09:20AM",
                      Day:"TUESDAY",
                      Place:"A101"
                    }
                ]
            },            
        ]
    },
    {
      id:2,
      Semester:"1",
      CourseCode:"CSHU1863",
      CourseTitle:"Islamiat",
      Add:true,
      CourseType:"UNI",
      Sections:[
     //Course Sections list
          {
              Section:"E1",
              Status:"Close",
              Teacher:"Sameer Shahid",
              Capacity:50,
              CurrentCapacity:50,
              Days:[
                  {
                    StartTime:"08:00AM",
                    EndTime:"09:20AM",
                    Day:"MONDAY",
                    Place:"A011"
                  },
                  {
                    StartTime:"08:00AM",
                    EndTime:"09:20AM",
                    Day:"WEDNESDAY",
                    Place:"A009"
                  }
              ]
          },
          {
              Section:"E2",
              Status:"Open",
              Teacher:"Sameer Shahid",
              Capacity:50,
              CurrentCapacity:30,
              Days:[
                  {
                    StartTime:"08:00AM",
                    EndTime:"09:20AM",
                    Day:"TUESDAY",
                    Place:"A001"
                  },
                  {
                    StartTime:"08:00AM",
                    EndTime:"09:20AM",
                    Day:"FRIDAY",
                    Place:"A001"
                  }
              ]
          },
          {
              Section:"E3",
              Status:"Open",
              Teacher:"Hannan Tariq",
              Capacity:50,
              CurrentCapacity:49,
              Days:[
                  {
                    StartTime:"09:30AM",
                    EndTime:"10:50AM",
                    Day:"MONDAY",
                    Place:"A201"
                  },
                  {
                    StartTime:"08:00AM",
                    EndTime:"09:20AM",
                    Day:"TUESDAY",
                    Place:"A204"
                  }
              ]
          },            
      ]
  },
  {
    id:3,
    Semester:"1",
    CourseCode:"CSHU2833",
    CourseTitle:"Logic Thinking",
    Add:true,
    CourseType:"UNI",
    Sections:[
   //Course Sections list
        {
            Section:"E1",
            Status:"Close",
            Teacher:"Sameer Shahid",
            Capacity:50,
            CurrentCapacity:50,
            Days:[
                {
                  StartTime:"08:00AM",
                  EndTime:"09:20AM",
                  Day:"MONDAY",
                  Place:"A204"
                },
                {
                  StartTime:"08:00AM",
                  EndTime:"09:20AM",
                  Day:"WEDNESDAY",
                  Place:"A122"
                }
            ]
        },
        {
            Section:"E2",
            Status:"Open",
            Teacher:"Sameer Shahid",
            Capacity:50,
            CurrentCapacity:30,
            Days:[
                {
                  StartTime:"10:00AM",
                  EndTime:"11:20AM",
                  Day:"TUESDAY"
                },
                {
                  StartTime:"08:00AM",
                  EndTime:"09:20AM",
                  Day:"FRIDAY"
                }
            ]
        },
        {
          Section:"E3",
          Status:"Open",
          Teacher:"Hannan Tariq",
          Capacity:50,
          CurrentCapacity:49,
          Days:[
              {
                StartTime:"09:30AM",
                EndTime:"10:50AM",
                Day:"MONDAY"
              },
              {
                StartTime:"08:00AM",
                EndTime:"09:20AM",
                Day:"TUESDAY"
              }
          ]
        },            
    ]
},
{
  id:4,
  Semester:"1",
  CourseCode:"CSSS1723",
  CourseTitle:"Basic Electronics",
  Add:true,
  CourseType:"UNI",
  Sections:[
 //Course Sections list
      {
          Section:"E1",
          Status:"Close",
          Teacher:"Sameer Shahid",
          Capacity:50,
          CurrentCapacity:50,
          Days:[
              {
                StartTime:"08:00AM",
                EndTime:"09:20AM",
                Day:"MONDAY"
              },
              {
                StartTime:"08:00AM",
                EndTime:"09:20AM",
                Day:"WEDNESDAY"
              }
          ]
      },
      {
          Section:"E2",
          Status:"Open",
          Teacher:"Sameer Shahid",
          Capacity:50,
          CurrentCapacity:30,
          Days:[
              {
                StartTime:"10:00AM",
                EndTime:"11:20AM",
                Day:"TUESDAY"
              },
              {
                StartTime:"08:00AM",
                EndTime:"09:20AM",
                Day:"FRIDAY"
              }
          ]
      },
      {
          Section:"E3",
          Status:"Open",
          Teacher:"Hannan Tariq",
          Capacity:50,
          CurrentCapacity:49,
          Days:[
              {
                StartTime:"09:30AM",
                EndTime:"10:50AM",
                Day:"MONDAY"
              },
              {
                StartTime:"08:00AM",
                EndTime:"09:20AM",
                Day:"TUESDAY"
              }
          ]
      },            
  ]
},
{
  id:5,
  Semester:"2",
  CourseCode:"CSCP1011",
  CourseTitle:"	Programming Fundamentals",
  Add:true,
  CourseType:"CORE",
  Sections:[
 //Course Sections list
      {
          Section:"E1",
          Status:"Close",
          Teacher:"Sameer Shahid",
          Capacity:50,
          CurrentCapacity:50,
          Days:[
              {
                StartTime:"08:00AM",
                EndTime:"09:20AM",
                Day:"MONDAY"
              },
              {
                StartTime:"08:00AM",
                EndTime:"09:20AM",
                Day:"WEDNESDAY"
              }
          ]
      },
      {
          Section:"E2",
          Status:"Open",
          Teacher:"Sameer Shahid",
          Capacity:50,
          CurrentCapacity:30,
          Days:[
              {
                StartTime:"10:00AM",
                EndTime:"11:20AM",
                Day:"TUESDAY"
              },
              {
                StartTime:"08:00AM",
                EndTime:"09:20AM",
                Day:"FRIDAY"
              }
          ]
      },
      {
          Section:"E3",
          Status:"Open",
          Teacher:"Hannan Tariq",
          Capacity:50,
          CurrentCapacity:49,
          Days:[
              {
                StartTime:"09:30AM",
                EndTime:"10:50AM",
                Day:"MONDAY"
              },
              {
                StartTime:"08:00AM",
                EndTime:"09:20AM",
                Day:"TUESDAY"
              }
          ]
      },            
  ]
},
{
  id:6,
  Semester:"2",
  CourseCode:"CSHU1823",
  CourseTitle:"English-II",
  Add:true,
  CourseType:"UNI",
  Sections:[
  //Course Sections list
     {
         Section:"E1",
         Status:"Open",
         Teacher:"Ayesha Sadeeqe",
         Capacity:50,
         CurrentCapacity:10,
         Days:[
             {
               StartTime:"2:00PM",
               EndTime:"3:20PM",
               Day:"MONDAY"
             },
             {
               StartTime:"08:00AM",
               EndTime:"09:20AM",
               Day:"FRIDAY"
             }
         ]
     },
     {
         Section:"E2",
         Status:"Open",
         Teacher:"Ayesha Sadeeqe",
         Capacity:50,
         CurrentCapacity:2,
         Days:[
             {
               StartTime:"10:00AM",
               EndTime:"11:20AM",
               Day:"TUESDAY"
             },
             {
               StartTime:"08:00AM",
               EndTime:"09:20AM",
               Day:"FRIDAY"
             }
         ]
     },
     {
         Section:"E3",
         Status:"Open",
         Teacher:"Ali Noman",
         Capacity:50,
         CurrentCapacity:40,
         Days:[
             {
               StartTime:"11:00AM",
               EndTime:"12:20PM",
               Day:"WEDNESDAY"
             },
             {
               StartTime:"08:00AM",
               EndTime:"09:20AM",
               Day:"THURSDAY"
             }
         ]
     },
     {
         Section:"E4",
         Status:"Open",
         Teacher:"Ayesha Sadeeqe",
         Capacity:50,
         CurrentCapacity:10,
         Days:[
             {
               StartTime:"2:00PM",
               EndTime:"3:20PM",
               Day:"MONDAY"
             },
             {
               StartTime:"08:00AM",
               EndTime:"09:20AM",
               Day:"FRIDAY"
             }
         ]
     },
     {
         Section:"E5",
         Status:"Open",
         Teacher:"Ayesha Sadeeqe",
         Capacity:50,
         CurrentCapacity:2,
         Days:[
             {
               StartTime:"10:00AM",
               EndTime:"11:20AM",
               Day:"TUESDAY"
             },
             {
               StartTime:"08:00AM",
               EndTime:"09:20AM",
               Day:"FRIDAY"
             }
         ]
     },
     {
         Section:"E6",
         Status:"Open",
         Teacher:"Ali Noman",
         Capacity:50,
         CurrentCapacity:40,
         Days:[
             {
               StartTime:"11:00AM",
               EndTime:"12:20PM",
               Day:"WEDNESDAY"
             },
             {
               StartTime:"08:00AM",
               EndTime:"09:20AM",
               Day:"THURSDAY"
             }
         ]
     }            
    ]
}    
];